import "./NewsAndEvents.module.css";
import Header from "@/reusable_sections/Header";
import News from "./sections/News";
import Footer from "@/reusable_sections/Footer";
export default function NewsAndEventsPage() {
  return <div>
      <Header />
      <News />
      <Footer />
    </div>;
}